import React from "react";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { InputTextarea } from "primereact/inputtextarea";
import { Checkbox } from "primereact/checkbox";

const typeOptions = [
  { label: "Select Type", value: null },
  { label: "Theory", value: "theory" },
  { label: "Practical", value: "practical" },
];

// Common subject categories — editable, so custom values are still allowed.
const categoryOptions = [
  "Science",
  "Mathematics",
  "Languages",
  "Social Studies",
  "Humanities",
  "Arts",
  "Physical Education",
  "Religious Studies",
  "Computer / IT",
  "Vocational",
  "Other",
].map((c) => ({ label: c, value: c }));

const SubjectForm = ({ subject, setSubject }) => {
  const onChange = (e) => {
    const { name, value } = e.target;
    setSubject((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <div className="grid">
      <div className="col-12 md:col-6">
        <div className="p-field">
          <label htmlFor="name">Name</label>
          <InputText id="name" name="name" value={subject.name || ""} onChange={onChange} placeholder="Subject name" className="w-full" />
        </div>
      </div>
      <div className="col-12 md:col-6">
        <div className="p-field">
          <label htmlFor="code">Code</label>
          <InputText id="code" name="code" value={subject.code || ""} onChange={onChange} placeholder="e.g., CHEM101" className="w-full" />
        </div>
      </div>
      <div className="col-12 md:col-6">
        <div className="p-field">
          <label htmlFor="type">Type</label>
          <Dropdown id="type" name="type" value={subject.type ?? null} options={typeOptions} onChange={onChange} optionLabel="label" optionValue="value" placeholder="Select type" className="w-full" />
        </div>
      </div>
      <div className="col-12 md:col-6">
        <div className="p-field">
          <label htmlFor="category">Category</label>
          <Dropdown id="category" name="category" value={subject.category || null} options={categoryOptions} onChange={onChange} optionLabel="label" optionValue="value" editable placeholder="Select or type a category" className="w-full" showClear />
        </div>
      </div>
      <div className="col-12">
        <div className="p-field">
          <label htmlFor="description">Description</label>
          <InputTextarea id="description" name="description" value={subject.description || ""} onChange={onChange} autoResize rows={3} className="w-full" />
        </div>
      </div>
      <div className="col-12">
        <div className="p-field-checkbox">
          <Checkbox inputId="is_active" checked={subject.is_active !== false} onChange={(e) => setSubject((p) => ({ ...p, is_active: e.checked }))} />
          <label htmlFor="is_active">Active</label>
        </div>
      </div>
    </div>
  );
};

export default SubjectForm; 